import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormWrapper, FormComponent } from 'src/domains/layouts/shared/cms/form/Form.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { QuickLinkTraySelect } from 'src/main/cms/QuickLinkTray/QuickLinkTraySelect/QuickLinkTraySelect';
import { UploadImg } from 'src/components/UploadImg/UploadImg';
import { QuickLinkTrayRedirectOptions } from './QuickLinkTrayRedirectOptions';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const QuickLinkTrayForm = observer(() => {
    const { cmsState } = useAppStateContext();
    const {
        label,
        labelModel,
        labelStatus,
        redirectOption,
        uploadIcon,
        redirectOptions,
        handleCreate,
        handleReset,
        resetForm,
        handleEdit,
        isEditMode,
        isLoading,
        resetLabel,
    } = cmsState.quickLinkTrayState;

    return (
        <FormWrapper>
            <FormHeader
                isEditMode={isEditMode}
                defaultLabel='Create new quick link tray'
                editModeLabel='Edit quick link tray'
                resetForm={resetForm}
            />
            <FormComponent
                onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                    e.preventDefault();
                }}
            >
                <Loader isActive={isLoading} />

                <QuickLinkTraySelect
                    selectOptions={redirectOptions}
                    stateValue={redirectOption}
                    dataTest='select-ql-redirection'
                    onChangeCB={resetLabel}
                />

                <QuickLinkTrayRedirectOptions />

                <OldInput
                    label='Label*'
                    status={labelStatus}
                    formInputState={label}
                    model={labelModel}
                    dataTest='quick-link-name'
                />

                <UploadImg
                    title='Icon'
                    uploadImageState={uploadIcon}
                />

                <FormButtons
                    onCreate={handleCreate}
                    onUpdate={handleEdit}
                    onCancel={handleReset}
                    isEditMode={isEditMode}
                    dataTestCreate='create-quick-link'
                    dataTestUpdate='update-quick-link'
                />
            </FormComponent>
        </FormWrapper>
    );
});
